import { DesignToolsConfig } from '../config/config.schema';

const createShopConfig = (domain: string) => ({
  baseUrl: {
    bucketStorage: `https://media.${domain}`,
    mainDomainUrl: `${domain}`,
    floorImageUrl: `https://scripts.${domain}/preview3d/floor.jpeg`,
    s3BucketStorage: `https://design-tools-storage-prod.s3-accelerate.amazonaws.com`,
    restApi: `https://api.${domain}/api/design-store`,
  },
});
export const prodEnv: DesignToolsConfig = {
  stage: 'prod',
  shops: {
    ex: createShopConfig('expoprint.io'),
    mi: createShopConfig('miloprint.com'),
    vt: createShopConfig('vividtents.com'),
    ap: createShopConfig('squadmojo.com'),
  },
};
